// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1vvMo","colMin":"styles_colMin__1QL57","colCheckbox":"styles_colCheckbox__28TkH"};